import React, { useEffect, useState } from "react";
import { getCoverLetterFeedback } from "../services/aiService";

export default function AiFeedbackModal({
  open,
  onClose,
  coverLetterText,
  resumeText,
  jobText,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const missingFields = [];
  if (!coverLetterText) missingFields.push("Cover letter — link one via Documents, then select it when editing this application");
  if (!resumeText) missingFields.push("Resume — select one when editing this application");

  useEffect(() => {
    if (!open || missingFields.length > 0) return;

    async function loadFeedback() {
      setLoading(true);
      setError(null);
      setFeedback(null);
      try {
        const result = await getCoverLetterFeedback({
          resumeText,
          jobText,
          coverLetterText,
        });
        setFeedback(result);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    loadFeedback();
  }, [open, coverLetterText, resumeText, jobText, missingFields.length]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;

  return (
    <div className="ai-modal-overlay">
      <div className="ai-modal large">
        <div className="ai-modal-header">
          <h2>AI Review</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {missingFields.length > 0 ? (
          <div className="ai-modal-missing">
            <p className="ai-modal-missing-title">To get AI feedback, this application is missing:</p>
            <ul>
              {missingFields.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          </div>
        ) : (
          <div className="ai-modal-body split">
            <div className="cover-letter-pane">
              <h3>Cover Letter</h3>
              <pre>{coverLetterText}</pre>
            </div>

            <div className="feedback-pane">
              {loading && <p>Analyzing cover letter...</p>}
              {error && <p className="error">{error}</p>}

              {feedback && (
                <>
                  {feedback.overview && (
                    <>
                      <h3>Overview</h3>
                      <p>{feedback.overview}</p>
                    </>
                  )}
                  {feedback.strengths?.length > 0 && (
                    <>
                      <h3>Strengths</h3>
                      <ul>{feedback.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                    </>
                  )}
                  {feedback.gaps?.length > 0 && (
                    <>
                      <h3>Gaps</h3>
                      <ul>{feedback.gaps.map((g, i) => <li key={i}>{g}</li>)}</ul>
                    </>
                  )}
                  {feedback.suggestions?.length > 0 && (
                    <>
                      <h3>Suggestions</h3>
                      <ul>{feedback.suggestions.map((s, i) => <li key={i}>{s}</li>)}</ul>
                    </>
                  )}
                  {feedback.tone_feedback && (
                    <>
                      <h3>Tone</h3>
                      <p>{feedback.tone_feedback}</p>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        <div className="ai-modal-footer">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
